import Employee from "./employee/employee_away.store";

export default {
  modules: { Employee },
};
